export const timeAction = (state = { activities: [] }, action) => {
  if (action.type === 'FETCH_TIMEACTION') {
    return action.payload;
  }

  if (action.type === 'CLEAR_TIMEACTION') {
    return { activities: [] };
  }

  return state;
};

export const userTimeActionTracking = (state = [], action) => {
  if (action.type === 'FETCH_USER_TIMEACTION_TRACKING') {
    return action.payload;
  }

  if (action.type === 'CLEAR_USER_TIMEACTION_TRACKING') {
    return [];
  }

  return state;
};

export const weeklyplans = (state = [], action) => {
  if (action.type === 'FETCH_WEEKLY_PLANS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_WEEKLY_PLANS') {
    return [];
  }

  return state;
};
